// src/evaluations/potentialReport/potentialReportStyles.js
// Estilos del Informe de Potencial (PLAN_UNIFICACION_ASSESSMENT.md §7).
// COPIA IDÉNTICA de grafton-assessment-backend:
// server/src/utils/assessment/potentialReportStyles.js (allá con module.exports).
// Todo va bajo .pr-root para no tocar el resto de la plataforma. Si se cambia
// uno, cambiar el otro: es lo que hace que la pestaña y el PDF se vean iguales.
export const POTENTIAL_REPORT_CSS = `
.pr-root { font-family: Arial, Helvetica, 'Liberation Sans', FreeSans, sans-serif; color: #2b2b2b; font-size: 11px; line-height: 1.35; text-align: left; letter-spacing: normal; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.pr-root *, .pr-root *::before, .pr-root *::after { box-sizing: border-box; }
.pr-root h1, .pr-root h2, .pr-root h3, .pr-root p, .pr-root ul, .pr-root ol, .pr-root li, .pr-root table, .pr-root figure { margin: 0; padding: 0; }
.pr-root ul, .pr-root ol { list-style: none; }
.pr-root table { border-collapse: collapse; border-spacing: 0; width: 100%; }
.pr-root img { display: block; }
.pr-root b, .pr-root strong { font-weight: 700; }

/* Hoja carta horizontal */
.pr-page { position: relative; width: 1056px; height: 816px; overflow: hidden; background: #ffffff; padding: 20px 28px 30px; display: flex; flex-direction: column; break-after: page; page-break-after: always; break-inside: avoid; }
.pr-page:last-child { break-after: auto; page-break-after: auto; }
.pr-header { display: flex; align-items: flex-start; height: 48px; flex: none; }
.pr-header-bar { flex: 1; min-width: 0; height: 26px; margin-top: 4px; background: #f05d2a; color: #ffffff; display: flex; align-items: center; justify-content: space-between; padding: 0 14px; }
.pr-header-title { font-size: 15px; font-weight: 700; white-space: nowrap; }
.pr-header-name { font-size: 11px; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 16px; }
.pr-header-logo { width: 150px; height: 48px; margin-left: 16px; flex: none; display: flex; align-items: center; justify-content: flex-end; }
.pr-header-logo img { max-width: 150px; max-height: 48px; width: auto; height: auto; object-fit: contain; }
.pr-body { flex: 1; min-height: 0; margin-top: 14px; display: flex; flex-direction: column; }
.pr-footer { position: absolute; left: 28px; right: 28px; bottom: 10px; display: flex; justify-content: space-between; font-size: 9px; color: #8a8a8a; }

/* Títulos */
.pr-page-title { flex: none; height: 26px; margin-bottom: 12px; background: #343331; color: #ffffff; font-size: 13px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
.pr-box-title { flex: none; height: 26px; padding: 0 8px; background: #343331; color: #ffffff; font-size: 13px; font-weight: 700; display: flex; align-items: center; justify-content: center; text-align: center; white-space: nowrap; overflow: hidden; }
.pr-sub-title { flex: none; height: 22px; padding: 0 10px; background: #d4d3d6; color: #343331; font-size: 12px; font-weight: 700; display: flex; align-items: center; white-space: nowrap; overflow: hidden; }

/* Grillas */
.pr-grid { flex: 1; min-height: 0; display: grid; gap: 14px 16px; }
.pr-box { display: flex; flex-direction: column; min-width: 0; min-height: 0; overflow: hidden; }
.pr-box-body { flex: 1; min-height: 0; overflow: hidden; padding: 8px 2px 0; display: flex; flex-direction: column; }
.pr-grid-summary { grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: 196px minmax(0, 1fr) minmax(0, 1fr); grid-template-areas: "personal trajectory ninebox" "competencies reasoning ninebox" "integrity strengths development"; }
.pr-grid-summary-simple { grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: 196px minmax(0, 1fr); grid-template-areas: "personal score ranking" "bars bars vision"; }
.pr-grid-disc { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: repeat(2, minmax(0, 1fr)); grid-template-areas: "char motivators" "diamond emotional"; gap: 14px 24px; }
.pr-grid-comp-first { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: repeat(2, minmax(0, 1fr)); grid-template-areas: "table c1" "ranking c2"; gap: 12px 24px; }
.pr-grid-comp-first.pr-no-ranking { grid-template-areas: "table c1" "c2 c3"; }
.pr-grid-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: repeat(2, minmax(0, 1fr)); grid-template-areas: "c1 c2" "c3 c4"; gap: 12px 24px; }
.pr-grid-quad { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: repeat(2, minmax(0, 1fr)); gap: 14px 24px; }
.pr-grid-plan { grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: minmax(0, 1fr); gap: 14px 18px; }
.pr-area-personal { grid-area: personal; }
.pr-area-trajectory { grid-area: trajectory; }
.pr-area-ninebox { grid-area: ninebox; }
.pr-area-competencies { grid-area: competencies; }
.pr-area-reasoning { grid-area: reasoning; }
.pr-area-integrity { grid-area: integrity; }
.pr-area-strengths { grid-area: strengths; }
.pr-area-development { grid-area: development; }
.pr-area-score { grid-area: score; }
.pr-area-ranking { grid-area: ranking; }
.pr-area-bars { grid-area: bars; }
.pr-area-vision { grid-area: vision; }
.pr-area-char { grid-area: char; }
.pr-area-motivators { grid-area: motivators; }
.pr-area-diamond { grid-area: diamond; }
.pr-area-emotional { grid-area: emotional; }
.pr-area-table { grid-area: table; }
.pr-area-c1 { grid-area: c1; }
.pr-area-c2 { grid-area: c2; }
.pr-area-c3 { grid-area: c3; }
.pr-area-c4 { grid-area: c4; }

/* Recorte de líneas */
.pr-clamp-1, .pr-clamp-2, .pr-clamp-3, .pr-clamp-4, .pr-clamp-5, .pr-clamp-6, .pr-clamp-14, .pr-clamp-28 { display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; }
.pr-clamp-1 { -webkit-line-clamp: 1; }
.pr-clamp-2 { -webkit-line-clamp: 2; }
.pr-clamp-3 { -webkit-line-clamp: 3; }
.pr-clamp-4 { -webkit-line-clamp: 4; }
.pr-clamp-5 { -webkit-line-clamp: 5; }
.pr-clamp-6 { -webkit-line-clamp: 6; }
.pr-clamp-14 { -webkit-line-clamp: 14; }
.pr-clamp-28 { -webkit-line-clamp: 28; }

/* Campos, listas, textos */
.pr-field { margin-bottom: 9px; }
.pr-field-label { font-size: 10px; font-weight: 700; color: #343331; }
.pr-field-value { font-size: 12.5px; line-height: 1.25; }
.pr-na { color: #8a8a8a; font-style: italic; font-size: 11px; }
.pr-na-box { flex: 1; min-height: 56px; margin: 0 0 2px; padding: 10px; border: 1px dashed #c4c3c6; border-radius: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; color: #8a8a8a; }
.pr-na-title { font-size: 13px; font-weight: 700; color: #6b6b6b; }
.pr-na-reason { font-size: 10.5px; margin-top: 3px; }
.pr-list li { position: relative; padding-left: 12px; margin-bottom: 5px; font-size: 11px; line-height: 1.3; }
.pr-list li::before { content: ''; position: absolute; left: 2px; top: 0.45em; width: 4px; height: 4px; border-radius: 50%; background: #343331; }
.pr-list-sm li { font-size: 10px; margin-bottom: 3px; line-height: 1.25; }
.pr-list-improve li::before { background: #f05d2a; }
.pr-para { font-size: 11px; line-height: 1.38; margin-bottom: 9px; text-align: justify; }
.pr-text { font-size: 10.5px; line-height: 1.45; text-align: justify; white-space: pre-line; }
.pr-muted { color: #8a8a8a; }
.pr-note { flex: none; font-size: 9px; color: #8a8a8a; margin-top: 2px; }
.pr-list + .pr-note { margin-top: 4px; font-style: italic; }

/* Barras horizontales */
.pr-bars { flex: 1; min-height: 0; display: flex; flex-direction: column; padding-right: 12px; }
.pr-bars-rows { position: relative; flex: 1; min-height: 0; display: flex; flex-direction: column; justify-content: space-around; }
.pr-bar-grid { position: absolute; top: 0; bottom: 0; left: 118px; right: 0; background-image: linear-gradient(to right, #e6e6e6 1px, transparent 1px); background-size: 20% 100%; border-right: 1px solid #e6e6e6; }
.pr-bar-row { position: relative; display: flex; align-items: center; min-height: 0; }
.pr-bar-label { width: 118px; flex: none; padding-right: 8px; text-align: right; font-size: 10px; line-height: 1.15; color: #3a3a3a; }
.pr-bar-track { flex: 1; min-width: 0; height: 16px; display: flex; align-items: center; }
.pr-bar-fill { height: 100%; min-width: 2px; padding-right: 4px; display: flex; align-items: center; justify-content: flex-end; }
.pr-bar-value { font-size: 9.5px; font-weight: 700; white-space: nowrap; }
.pr-bar-value-out { margin-left: 4px; color: #3a3a3a; }
.pr-bar-axis { flex: none; position: relative; height: 12px; margin: 3px 0 0 118px; font-size: 8px; color: #8a8a8a; }
.pr-bar-axis span { position: absolute; top: 0; transform: translateX(-50%); }
.pr-bars-dense .pr-bar-track { height: 13px; }
.pr-bars-wide .pr-bar-label { width: 190px; font-size: 11px; }
.pr-bars-wide .pr-bar-axis { margin-left: 190px; }
.pr-bars-wide .pr-bar-grid { left: 190px; }
.pr-bars-wide .pr-bar-track { height: 20px; }
.pr-bars-wide .pr-bar-value { font-size: 10.5px; }

/* Nine Box */
.pr-ninebox { flex: 1; min-height: 0; display: grid; grid-template-columns: 18px minmax(0, 1fr); grid-template-rows: minmax(0, 1fr) 18px; padding-top: 8px; }
.pr-ninebox-y { grid-column: 1; grid-row: 1; display: flex; align-items: center; justify-content: center; }
.pr-ninebox-y span { transform: rotate(-90deg); white-space: nowrap; font-size: 9.5px; font-weight: 700; color: #6b6b6b; }
.pr-ninebox-grid { grid-column: 2; grid-row: 1; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: repeat(3, minmax(0, 1fr)); border-top: 1px solid #9a9a9a; border-left: 1px solid #9a9a9a; }
.pr-ninebox-cell { min-width: 0; min-height: 0; padding: 4px; border-right: 1px solid #9a9a9a; border-bottom: 1px solid #9a9a9a; display: flex; align-items: center; justify-content: center; text-align: center; font-size: 11px; line-height: 1.2; }
.pr-ninebox-cell-on { background: #f05d2a; color: #ffffff; font-weight: 700; }
.pr-ninebox-x { grid-column: 2; grid-row: 2; display: flex; align-items: center; justify-content: center; font-size: 9.5px; font-weight: 700; color: #6b6b6b; }
.pr-ninebox-scores { flex: none; display: flex; justify-content: space-around; padding: 8px 0 2px; font-size: 11px; }
.pr-ninebox-scores b { font-size: 13px; }

/* Razonamiento */
.pr-reason { table-layout: fixed; }
.pr-reason th { padding: 0 1px 4px; font-size: 8.5px; font-weight: 700; line-height: 1.1; color: #3a3a3a; text-align: center; vertical-align: bottom; }
.pr-reason td { padding: 3px 2px; text-align: center; vertical-align: middle; }
.pr-reason tbody tr { height: 35px; }
.pr-reason .pr-reason-name { width: 104px; text-align: left; }
.pr-reason td.pr-reason-name { font-size: 10px; font-weight: 700; line-height: 1.15; }
.pr-reason .pr-reason-gauge-col { width: 60px; }
.pr-reason-cell { display: block; height: 14px; border: 1px solid #343331; }
.pr-gauge { position: relative; width: 52px; height: 28px; margin: 0 auto; }
.pr-gauge svg { position: absolute; left: 0; top: 0; display: block; }
.pr-gauge-text { position: absolute; left: 0; right: 0; bottom: 2px; font-size: 10px; font-weight: 700; line-height: 1; text-align: center; white-space: nowrap; }
.pr-reason-missing { display: inline-block; font-size: 9px; font-style: italic; line-height: 1.15; color: #8a8a8a; }
.pr-reason-legend { flex: none; margin-top: 4px; font-size: 8.5px; color: #8a8a8a; }

/* DISC */
.pr-pies { flex: none; display: flex; align-items: center; margin-top: 6px; }
.pr-pie { width: 104px; flex: none; display: flex; flex-direction: column; align-items: center; }
.pr-pie-title { margin-bottom: 4px; font-size: 10px; font-weight: 700; }
.pr-pie svg { display: block; width: 88px; height: 88px; }
.pr-pie-legend { flex: 1; min-width: 0; margin-left: 10px; }
.pr-pie-legend th { padding: 0 4px 3px; font-size: 9.5px; font-weight: 700; color: #6b6b6b; text-align: center; }
.pr-pie-legend td { padding: 2px 4px; font-size: 10.5px; text-align: center; }
.pr-pie-legend td.pr-pie-letter { text-align: left; font-weight: 700; }
.pr-chip { display: inline-block; width: 10px; height: 10px; border-radius: 2px; margin-right: 5px; vertical-align: -1px; }
.pr-disc-style { flex: none; margin-top: 8px; font-size: 12px; }
.pr-disc-legend { flex: none; margin-top: 2px; font-size: 9px; color: #8a8a8a; }
.pr-diamond-wrap { flex: 1; min-height: 0; display: flex; align-items: center; justify-content: center; padding-top: 6px; }
.pr-diamond { position: relative; width: 270px; height: 270px; flex: none; }
.pr-diamond svg { position: absolute; left: 0; top: 0; width: 100%; height: 100%; display: block; }
.pr-diamond-legend { width: 168px; margin-left: 18px; font-size: 10px; }
.pr-diamond-legend-row { display: flex; align-items: center; margin-bottom: 7px; }
.pr-dot-natural { width: 12px; height: 12px; flex: none; margin-right: 7px; border-radius: 50%; background: #3b82f6; }
.pr-dot-adapted { width: 9px; height: 9px; flex: none; margin: 0 8.5px 0 1.5px; border-radius: 50%; background: #111827; }

/* Competencias */
.pr-comp-table { margin-top: 0; }
.pr-comp-table th { padding: 4px 8px; background: #f05d2a; color: #ffffff; font-size: 11px; font-weight: 700; text-align: left; }
.pr-comp-table td { padding: 3.5px 8px; font-size: 11px; border-bottom: 1px solid #ffffff; }
.pr-comp-table .pr-num { width: 92px; text-align: right; font-weight: 700; }
.pr-comp-table tfoot td { padding-top: 7px; font-size: 13px; font-weight: 700; border: none; background: transparent; }
.pr-comp-table.pr-dense td { padding: 2px 8px; font-size: 10px; }
.pr-scale { flex: none; margin-top: 10px; display: flex; flex-wrap: wrap; gap: 4px 12px; font-size: 9.5px; color: #3a3a3a; }
.pr-scale-item { display: flex; align-items: center; }
.pr-scale-dot { width: 9px; height: 9px; flex: none; margin-right: 4px; border-radius: 50%; }
.pr-scale-list { flex-direction: column; align-items: flex-start; gap: 0; margin-top: 0; padding-left: 10px; }
.pr-scale-list .pr-scale-item { margin-bottom: 4px; font-size: 10px; }
.pr-ranking { display: flex; }
.pr-ranking-col { flex: 1; min-width: 0; }
.pr-ranking-col + .pr-ranking-col { margin-left: 16px; }
.pr-ranking-head { margin-bottom: 4px; font-size: 10.5px; font-weight: 700; color: #343331; }
.pr-ranking-item { display: flex; align-items: center; justify-content: space-between; padding: 3px 0; border-bottom: 1px solid #ececec; font-size: 10.5px; }
.pr-ranking-name { flex: 1; min-width: 0; display: flex; align-items: center; }
.pr-ranking-name span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pr-ranking-dot { width: 8px; height: 8px; flex: none; margin-right: 6px; border-radius: 50%; }
.pr-ranking-score { flex: none; margin-left: 8px; font-weight: 700; }
.pr-card { display: flex; flex-direction: column; min-width: 0; min-height: 0; overflow: hidden; padding: 8px 10px 6px; border: 1px solid #e2e2e2; border-left: 4px solid #343331; background: #ffffff; }
.pr-card-head { flex: none; display: flex; align-items: baseline; justify-content: space-between; }
.pr-card-name { min-width: 0; font-size: 13px; font-weight: 700; }
.pr-card-score { flex: none; margin-left: 10px; font-size: 13px; font-weight: 700; }
.pr-card-meta { flex: none; margin: 2px 0 6px; font-size: 9.5px; color: #7a7a7a; }
.pr-card-cols { flex: 1; min-height: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.pr-card-col { min-width: 0; min-height: 0; overflow: hidden; }
.pr-card-col-title { margin-bottom: 4px; font-size: 10px; font-weight: 700; color: #2f9766; }
.pr-card-col-title.pr-improve { color: #f05d2a; }

/* Puntaje general (simple) */
.pr-score-big { margin-top: 6px; font-size: 40px; font-weight: 700; line-height: 1.1; text-align: center; }
.pr-score-level { margin: 2px 0 10px; font-size: 12px; font-weight: 700; text-align: center; }

/* Conclusión y textos largos */
.pr-columns { flex: 1; min-height: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 28px; }
.pr-column { min-width: 0; min-height: 0; overflow: hidden; }
.pr-section { margin-bottom: 14px; }
.pr-section .pr-sub-title { margin-bottom: 6px; }
.pr-plan-intro { flex: none; margin-bottom: 10px; }
.pr-plan-group { margin-top: 8px; }
.pr-plan-group-title { margin-bottom: 3px; font-size: 10.5px; font-weight: 700; color: #343331; }

/* Portada */
.pr-page.pr-cover { padding: 0; }
.pr-cover-top { height: 452px; flex: none; display: flex; }
.pr-cover-logo { width: 50%; padding: 40px; display: flex; align-items: center; justify-content: center; }
.pr-cover-logo img { max-width: 340px; max-height: 190px; width: auto; height: auto; object-fit: contain; }
.pr-cover-id { width: 50%; padding: 34px 40px 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.pr-cover-title { margin-bottom: 22px; font-size: 34px; font-weight: 700; line-height: 1.15; color: #6b2c91; text-align: center; }
.pr-cover-photo { width: 120px; height: 120px; margin-bottom: 18px; border-radius: 6px; background: #eef1f6; display: flex; align-items: flex-end; justify-content: center; overflow: hidden; }
.pr-cover-photo svg { display: block; width: 104px; height: 104px; }
.pr-cover-field { margin-bottom: 4px; font-size: 15px; text-align: center; }
.pr-cover-band { height: 22px; flex: none; background: #f05d2a; }
.pr-cover-bottom { flex: 1; min-height: 0; padding: 36px 56px; display: flex; justify-content: space-between; }
.pr-cover-meta { font-size: 13px; line-height: 1.8; }
.pr-cover-mode { max-width: 420px; padding-top: 6px; border-top: 1px solid #c4c3c6; font-size: 13px; line-height: 1.8; text-align: right; align-self: flex-start; }
`;
